webpackJsonp([165],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(891);


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(695);
	
	__webpack_require__(1141);
	
	__webpack_require__(1139);

/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

	// JavaScript Document
	
	jQuery(function($){
	$('a[rel=tooltip]').popover();
	});


/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

	// JavaScript Document
	
	function openReminderWindow(url){
	    window.open(url, 'mywindow1', 'width=600, height=400, menubar=no, toolbar=no, scrollbars=yes');
	}


/***/ })

});


// WEBPACK FOOTER //
// javascripts/user-page-js/main/login.page.js